import { useTranslation } from "@sagot/i18n";
import { useMemo } from "react";
import { LIMITS, availabilitySchema, type AvailabilityMessages } from "./availability-model";

/** Localized zod schema of the availability editor (same rules as the backend). */
export function useAvailabilitySchema() {
  const { t } = useTranslation();
  return useMemo(() => {
    const P = "build.actions.availability.errors";
    const messages: AvailabilityMessages = {
      clock: t(`${P}.clock`),
      rangeOrder: t(`${P}.rangeOrder`),
      overlap: t(`${P}.overlap`),
      maxRanges: t(`${P}.maxRanges`, { count: LIMITS.windowsPerDay }),
      noOpenDay: t(`${P}.noOpenDay`),
      slotMinutes: t(`${P}.slotMinutes`),
      bufferMinutes: t(`${P}.bufferMinutes`),
      minNoticeHours: t(`${P}.minNoticeHours`),
      horizonDays: t(`${P}.horizonDays`),
      dateInvalid: t("build.actions.availability.blocked.invalid"),
      blockedMax: t(`${P}.blockedMax`, { count: LIMITS.blockedDates }),
      locationMax: t(`${P}.locationMax`, { count: LIMITS.location }),
      timezone: t(`${P}.timezone`),
    };
    return availabilitySchema(messages);
  }, [t]);
}
